import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Icons
import { IoTrash } from 'react-icons/io5';

// Components
import Typography from '../Typography';
import Button from '../CustomButton';
import TextInput from '../TextInput';

// Styles
import styles from './style.module.scss';

const isValidURL = (value: string) => {
  if (!value.trim()) return true; // Empty value is valid (user might still be typing)

  try {
    // If the URL doesn't have a protocol, prepend https://
    const urlToTest = value.trim().startsWith('http://') || value.trim().startsWith('https://')
      ? value.trim()
      : `https://${value.trim()}`;

    const url = new URL(urlToTest);

    // Basic validation: must have a hostname with at least one dot
    return url.hostname.includes('.') && url.hostname.length > 3;
  } catch {
    return false;
  }
};

interface LinkRowProps {
  id: string;
  url: string;
  onRemove: (id: string) => void;
  hasMore?: boolean;
  onLinkChange: (id: string, url: string) => void;
  isInvalid?: boolean;
}

const LinkRow: React.FC<LinkRowProps> = ({ id, url, onRemove, hasMore = false, onLinkChange }) => {
  const { t } = useTranslation();

  const [isInvalid, setIsInvalid] = useState(false);

  const handleChangeLink = useCallback((value: string) => {
    onLinkChange(id, value);
    setIsInvalid(!isValidURL(value));
  }, [id, onLinkChange]);

  return (
    <div className={styles.link_row}>
      <TextInput
        adornmentLeft={
          <div className={styles.link_row_adornment_left}>
            <Typography variant='p'>
              {t('attachMaterials.https')}
            </Typography>
          </div>
        }
        classes={{
          root: styles.link_row_input,
        }}
        error={isInvalid ? t('attachMaterials.invalid_link') : undefined}
        value={url}
        onChange={handleChangeLink}
      />

      {hasMore && (
        <Button
          variant='text'
          classes={{ root: styles.link_row_remove }}
          onClick={() => onRemove(id)}
        >
          <IoTrash />
        </Button>
      )}
    </div>
  )
}

export default LinkRow;
